import { config, executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const removeSettlement = (req: any, userAccessToken: string) => {
  const request: Request<{}> = {
    config: config.mockable3,
    apiPath: APIEndPoints.SettlementRemove,
    method: 'POST',
    cache: false,
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { removeSettlement }
